import {connect} from 'react-redux';
import labPartnerContainer from './labPartnerContainer';

export interface State {
    textEnums: any,
}

export const mapState = (state: State) => {
    return {
        labPartners: state.textEnums.labPartners,
    };
};

export default connect(mapState)(labPartnerContainer);
